import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  selector: 'app-institution-selection',
  templateUrl: './institution-selection.component.html',
  styleUrls: ['./institution-selection.component.css']
})
export class InstitutionSelectionComponent {

  // TODO introduce simplified interface
  // TODO passing in groups is likely unintended. Consider filtering groups before passing them to the component and remove the logic here
  @Input() institutionList: Array<{ institution: { institution: { institutionID: number, isGroup: boolean, institutionName: string } } }>;

  /**
   * Whether to show a validation error (red border).
   */
  @Input() showInvalid: boolean;

  /**
   * All currently checked institutions.
   *
   * Make sure to update the bound property in the parent component via `checkedInstitutionIdsChange`!
   */
  @Input() checkedInstitutionIds: Array<number> = [];
  @Output() checkedInstitutionIdsChange = new EventEmitter<Array<number>>();

  /**
   * The current value of the checkbox "select all".
   */
  selectAllChecked: boolean;

  /**
   * The current value of the search input box.
   */
  searchText: string;

  checkAll(ev) {
    const checked = ev.target.checked;

    if (checked) {
      // select all options

      // TODO in some cases, this.institutionList can contain groups, which are not displayed in the UI,
      //  but WILL be (silently) selected this way!
      const checkedInstitutions = this.institutionList
        .filter(i => !i.institution.institution.isGroup)
        .map(i => i.institution.institution.institutionID);

      this.checkedInstitutionIdsChanged(checkedInstitutions);
    } else {
      // checkbox was toggled off: deselect all options
      this.checkedInstitutionIdsChanged([]);
    }
  }

  checkOne(ev, institutionId: number) {
    const checked = ev ? ev.target.checked : false;

    if (checked) {
      // option was added
      const checkedInstitutions = [...this.checkedInstitutionIds, institutionId];

      this.checkedInstitutionIdsChanged(checkedInstitutions);
    } else {
      // option was disabled, remove the id
      const checkedInstitutions =
        this.checkedInstitutionIds
          .filter(id => id != institutionId);

      // if some item has been deselected, "select all" is no longer correct
      if (this.selectAllChecked) {
        this.selectAllChecked = false;
      }

      this.checkedInstitutionIdsChanged(checkedInstitutions);
    }
  }

  isChecked(institutionID: number) {
    return this.checkedInstitutionIds.includes(institutionID)
  }

  /**
   * Propagate intended changes to parent component
   * @param checkedInstitutions
   * @private
   */
  private checkedInstitutionIdsChanged(checkedInstitutions: number[]) {
    this.checkedInstitutionIdsChange.emit(checkedInstitutions);
  }

  getInstitutionName(institutionId) {
    return this.institutionList.find(i => i.institution.institution.institutionID === institutionId).institution.institution.institutionName;
  }

  cleanSearch(){
    delete this.searchText;
  }
}
